<template>
    <div>
        <PlanDetailsHeader :header="model" :continue="planContinue" :recurrenceDays="recurrenceDays" @add="handleAddCart" />
        <PlanDetailsIcons 
            v-if="!this.model.hide_details"
            :count="count" 
        />
        <PlanDetailsDescription :description="model.translation.description" />
        <div
            v-if="model.release_date"
            class="container"
        >
            <spam
                class="bg-primary text-secondary px-2 rounded"
            >
                {{ $t('dashboard.plan.release_date') }}
                <b>{{ $moment(model.release_date).format('DD/MM/YYYY') }}</b>
            </spam>
        </div>
        <PlanDetailContent
            v-if="!this.model.hide_details"
            class="mb-6"
            :model="model"
        />
        <CartAddRecurrence v-model="addCartModal" :planId="model.id" />
    </div>
</template>

<script>
import PlanDetailsHeader from "../components/PlanDetailsComponents/PlanDetailHeader";
import PlanDetailsVideo from "../components/PlanDetailsComponents/PlanDetailsVideo";
import PlanDetailsDescription from "../components/PlanDetailsComponents/PlanDetailsDescription";
import PlanDetailContent from "../components/PlanDetailsComponents/PlanDetailContent";
import PlanDetailsIcons from "../components/PlanDetailsComponents/PlanDetailsIcons";

import CartAddRecurrence from "./CartComponents/CartAddRecurrence";

export default {
    name: "PlanDetails",

    components: {
        PlanDetailsVideo,
        PlanDetailContent,
        PlanDetailsHeader,
        PlanDetailsDescription,
        PlanDetailsIcons,
        CartAddRecurrence
    },

    props: {
        model: {
            type: Object,
            required: true
        },
        count: {
            type: Object,
            required: true
        },
        planContinue: Boolean,
        recurrenceDays: {
            type: Number,
            required: true
        },
    },

    data() {
        return {
            addCartModal: false,
            loading: true
        };
    },
    
    methods: {
        handleAddCart() {
            return window.axios
                .post(`/api/cart/add/${this.model.id}`, {
                    recurrence_option: this.model.recurrence_option?.id,
                })
                .then(res => {
                    if (res.data.status === 304) {
                        this.addCartModal = true;
                        return;
                    }
                    this.$notify({
                        type: "success",
                        message: this.$t(res.data.message)
                    });
                    this.$store.commit("ADD_CART_ITEM");
                    if (this.model.type === 1) {
                        window.location.replace("/app/dashboard");
                    } else window.location.replace("/cart");
                })
                .catch(err => {
                    this.$notify({
                        type: "danger",
                        message: this.$t(err.response.data.error)
                    });
                });
        }
    }
};
</script>

<style>
</style>
